import customSelect from "custom-select";
export default {
  name: "custom-select",
};

document.addEventListener("DOMContentLoaded", function () {
  const selectElements = document.querySelectorAll(
    ".wpcf7-form select.custom-select",
  );

  selectElements.forEach((selectEl) => {
    const customSelectInstance = customSelect(selectEl, {
      containerClass: "custom-select-container",
      openerClass: "custom-select-opener",
      panelClass: "custom-select-panel",
      optionClass: "custom-select-option",
      isSelectedClass: "is-selected",
      isOpenClass: "is-open",
    });

    // Ajouter une icône personnalisée
    if (customSelectInstance && customSelectInstance[0]) {
      const iconContainer = document.createElement("div");
      iconContainer.innerHTML = `
        <div class="custom-select-icon-wrapper">
          <svg class="custom-select-icon icon icon--night-blue" width="18" height="9">
            <use href="#icon-arrow-down"></use>
          </svg>
        </div>
      `;
      customSelectInstance[0].container.appendChild(
        iconContainer.firstElementChild,
      );
    }
  });

  // Synchroniser les boutons custom avec le champ CF7
  const customRadios = document.querySelectorAll("input[data-cf7-sync]");

  customRadios.forEach((radio) => {
    radio.addEventListener("change", function () {
      if (this.checked) {
        const cf7FieldName = this.getAttribute("data-cf7-sync");
        const cf7Radios = document.querySelectorAll(
          `input[name="${cf7FieldName}"]`,
        );

        cf7Radios.forEach((cf7Radio) => {
          if (cf7Radio.value === this.value) {
            cf7Radio.checked = true;
          }
        });
      }
    });
  });
});
